import { render, staticRenderFns } from "./Homeworks.vue?vue&type=template&id=2da85bff&scoped=true&"
import script from "./Homeworks.vue?vue&type=script&lang=js&"
export * from "./Homeworks.vue?vue&type=script&lang=js&"
import style0 from "./Homeworks.vue?vue&type=style&index=0&id=2da85bff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da85bff",
  null
  
)

export default component.exports